/* eslint-disable jsx-a11y/anchor-is-valid */
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';
import joinUs from '../public/icons/last_version/footer-logo.svg';
import { breakPoints, fontFamily, colors } from './styles/variables';
import banner from '../public/banner/join-us.png';

const Container = styled.div`
  position: relative;
  height: 70rem;
  z-index: 1;
  overflow: hidden;

  .content {
    margin-top: 50px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    z-index: 10;
  }

  .join-us {
    margin: 0 auto;
    img {
      width: 500px;
      max-width: 100%;
    }
    @media (max-width: ${breakPoints.medium}px) {
      padding: 0 30px;
    }
  }

  .join-us-text {
    font-size: 2em;
    font-family: ${fontFamily.headings};
    color: ${colors.purple};
    text-align: center;
    margin: 1em 0;
    color: #182e4f;

    @media (max-width: ${breakPoints.medium}px) {
      font-size: 1.5em;
    }
  }

  .social-container {
    display: flex;
    flex-direction: row;
    justify-content: center;

    div {
      margin: 0 10px;
    }
  }

  .image-container {
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;

    img {
      position: absolute;
      left: 0;
      height: 100%;
      transform: translate(-25%, 0);
    }
  }
`;

function JoinUsBanner() {
  return (
    <Container>
      {/* Background */}
      <div className="image-container">
        <Image src={banner.src} alt="Pirates footer banner" />
      </div>

      <div className="content">
        <div className="join-us">
          <Image src={joinUs.src} alt="Pirates of Metaverse" />
          <div className="join-us-text">JOIN THE CREW!</div>
        </div>

        <div className="social-container">
          <div>
            <Link href="https://discord.gg/SfE4GvHp7T">
              <a target="_blank">
                <Image
                  src="/icons/last_version/discord_blue.svg"
                  width="30px"
                  height="30px"
                  alt="Pirates Discord"
                />
              </a>
            </Link>
          </div>
          <div>
            <Link href="https://twitter.com/PiratesMeta">
              <a target="_blank">
                <Image
                  src="/icons/last_version/twitter_blue.svg"
                  width="30px"
                  height="30px"
                  alt="Pirates Twitter"
                />
              </a>
            </Link>
          </div>
          <div>
            <Link href="https://www.instagram.com/piratesmeta/">
              <a className="twitter-icon" target="_blank">
                <Image
                  src="/icons/last_version/insta_blue.svg"
                  width="30px"
                  height="30px"
                  alt="Pirates Instagram"
                />
              </a>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default JoinUsBanner;
